import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { LatestUpdatesInitialStateType } from '../utils/Types';

import { isAPISuccess } from '../utils/Util';
import { API_STATUS, BlankPagination } from '../utils/Constant';
import {
  addLatestUpdate,
  removeLatestUpdate,
  getAllLatestUpdates,
} from '../services';
const blankLatestUpdates = {
  updates: [],
  pagination: BlankPagination,
};
const initialState: LatestUpdatesInitialStateType = {
  allList: blankLatestUpdates,
  allListAPIStatus: '',
};

export const getLatestUpdatesAllList = createAsyncThunk<any, any>(
  'latestUpdates/getLatestUpdatesAllList',
  async (data: any) => {
    const res = await getAllLatestUpdates(data);
    return res.data;
  }
);

export const removeUpdate = createAsyncThunk<any, any>(
  'latestUpdates/removeUpdate',
  async (params: any) => {
    const res = await removeLatestUpdate(params);
    return res.data;
  }
);

export const addNewUpdate = createAsyncThunk<any, any>(
  'latestUpdates/addNewUpdate',
  async (params: any) => {
    const res = await addLatestUpdate(params);
    return res.data;
  }
);

export const latestUpdatesSlice = createSlice({
  name: 'latestUpdates',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getLatestUpdatesAllList.pending, (state) => {
        state.allListAPIStatus = API_STATUS.LOADING;
      })
      .addCase(getLatestUpdatesAllList.fulfilled, (state, action) => {
        if (isAPISuccess(action.payload)) {
          state.allListAPIStatus = API_STATUS.SUCCEEDED;
          state.allList.updates = action.payload.result;
          state.allList.pagination = action.payload.pagination;
        } else {
          state.allListAPIStatus = API_STATUS.FAILED;
          state.allList = blankLatestUpdates;
          state.allList.pagination = BlankPagination;
        }
      });
  },
});

export const latestUpdatesSelector = (state: {
  latestUpdates: LatestUpdatesInitialStateType;
}) => state.latestUpdates;

export default latestUpdatesSlice.reducer;
